import { Route, Routes } from "react-router-dom";
import NotFound from "../pages/404";
import UserLayout from "../layouts/UserLayout";
import UserDashboard from "../pages/user/UserDashboard";
import UserChildren from "../pages/user/UserChildren";
import SingleChildDetails from "../pages/user/SingleChildDetails";
import UserEnrolment from "../pages/user/UserEnrolment";
import UserPayments from "../pages/user/UserPayments";
import PaymentCallback from "../pages/user/PaymentCallback";
import UserProgressReports from "../pages/user/UserProgressReports";
import UserShowcase from "../pages/user/UserShowcase";
import UserMessages from "../pages/user/UserMessages";
import UserSettings from "../pages/user/UserSettings";
import { LearnHome, LearnJourney } from "../pages/user/UserLearn";
import UserLearnWeek from "../pages/user/UserLearnWeek";
import UserKits from "../pages/user/UserKits";
import UserLearnShowcase from "../pages/user/UserLearnShowcase";
import ShowcaseCertificate from "../pages/user/ShowcaseCertificate";
import UserLearnProjects from "../pages/user/UserLearnProjects";

export const UserRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Printable page, outside the portal layout */}
      <Route
        path="/learn/:childId/showcase/:entryId/certificate"
        element={<ShowcaseCertificate />}
      />
      <Route element={<UserLayout />}>
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/children" element={<UserChildren />} />
        <Route path="/children/:id" element={<SingleChildDetails />} />
        <Route path="/enrolments" element={<UserEnrolment />} />
        <Route path="/payments" element={<UserPayments />} />
        <Route path="/payments/callback" element={<PaymentCallback />} />
        <Route path="/reports" element={<UserProgressReports />} />
        <Route path="/showcases" element={<UserShowcase />} />
        <Route path="/messages" element={<UserMessages />} />
        <Route path="/settings" element={<UserSettings />} />
        <Route path="/learn" element={<LearnHome />} />
        <Route path="/learn/:childId" element={<LearnJourney />} />
        <Route path="/learn/:childId/showcase" element={<UserLearnShowcase />} />
        <Route path="/learn/:childId/projects" element={<UserLearnProjects />} />
        <Route path="/learn/:childId/:weekKey" element={<UserLearnWeek />} />
        <Route path="/learn/:childId/:weekKey/:lessonKey" element={<UserLearnWeek />} />
        <Route path="/kits" element={<UserKits />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default UserRoutes;
